// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__a48ba87e23ed64c25815","cls2":"Comments-cls2__b6a003269e136170b246 Comments-cls1__a48ba87e23ed64c25815"};